import { endOfDay, format, isSameDay, startOfDay, startOfMonth, startOfYear, subDays, addDays, subYears, addYears, addMonths } from "date-fns";
import { today } from 'AppReact';

export const getSelectedTimeSpanName = ({ selectedTimeSpan, startDate, endDate, displayExactDates }) => {
  let text = '';
  if ((displayExactDates || selectedTimeSpan === 'custom') && startDate && endDate) {
    text = `${format(startDate, 'MM/dd/yyyy')} - ${format(endDate, 'MM/dd/yyyy')}`;
    return text;
  }
  if (selectedTimeSpan === 'lastWeek') {
    text = 'Last 7 Days';
  }
  if (selectedTimeSpan === 'lastMonth') {
    text = 'Last 30 Days';
  }
  if (selectedTimeSpan === 'today') {
    text = 'Today';
  }
  if (selectedTimeSpan === 'lastYear') {
    text = 'Last Year';
  }
  if (selectedTimeSpan === 'allTime') {
    text = 'All Time';
  }
  if (selectedTimeSpan === 'mtd') {
    text = 'MTD';
  }
  if (selectedTimeSpan === 'ytd') {
    text = 'YTD';
  }

  return text
}

export const getSelectedTimeSpanByDate = ({ startDate, endDate }) => {
  let selectedTimeSpan = 'custom';

  if (startDate && endDate) {
    if (isSameDay(startDate, window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10))) &&
      isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'allTime';
    }
    if (isSameDay(startDate, startOfDay(today()) && isSameDay(endDate, endOfDay(today())))) {
      selectedTimeSpan = 'today';
    }
    if (isSameDay(startDate, startOfDay(subDays(today(), 6))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'lastWeek'
    }
    if (isSameDay(startDate, startOfDay(subDays(today(), 29))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'lastMonth'
    }
    if (isSameDay(startDate, startOfDay(subYears(today(), 1))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'lastYear'
    }
    if (isSameDay(startDate, startOfDay(startOfYear(today()))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'ytd'
    }
    if (isSameDay(startDate, startOfDay(startOfMonth(today()))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'mtd'
    }
  }

  return selectedTimeSpan
}

export const getSelectedTimeSpanByDateSubscription = ({ startDate, endDate }) => {
  let selectedTimeSpan = 'all time';

  if (startDate && endDate) {
    if (isSameDay(startDate, window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10))) &&
      isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'all time';
    }
    if (isSameDay(startDate, startOfDay(today()) && isSameDay(endDate, endOfDay(today())))) {
      selectedTimeSpan = 'today';
    }
    if (isSameDay(startDate, startOfDay(subDays(today(), 6))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'last 7'
    }
    if (isSameDay(startDate, startOfDay(subDays(today(), 29))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'last 30'
    }
    if (isSameDay(startDate, startOfDay(subYears(today(), 1))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'last year'
    }
    if (isSameDay(startDate, startOfDay(startOfYear(today()))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'ytd'
    }
    if (isSameDay(startDate, startOfDay(startOfMonth(today()))) && isSameDay(endDate, endOfDay(today()))) {
      selectedTimeSpan = 'mtd'
    }
  }

  return selectedTimeSpan
}

export const getDatesFromTimeSpan = ({ timeSpan }) => {
  if (timeSpan === 'all time') {
    return { startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: today() }
  }
  if (timeSpan === 'today') {
    return { startDate: today(), endDate: today() }
  }
  if (timeSpan === 'last 7') {
    return { startDate: subDays(today(), 6), endDate: today() }
  }
  if (timeSpan === 'last 30') {
    return { startDate: subDays(today(), 29), endDate: today() }
  }
  if (timeSpan === 'last year') {
    return { startDate: subYears(today(), 1), endDate: today() }
  }
  if (timeSpan === 'ytd') {
    return { startDate: startOfYear(today()), endDate: today() }
  }
  if (timeSpan === 'mtd') {
    return { startDate: startOfMonth(today()), endDate: today() }
  }

  return { startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: today() }
}

export const getSelectedTimeByDate = (date) => {
  let selectedTimeOption = 'custom';

  if (date) {
    if (isSameDay(date, startOfDay(today()))) {
      selectedTimeOption = 'today';
    }
    if (isSameDay(date, startOfDay(addDays(today(), 1)))) {
      selectedTimeOption = 'tomorrow'
    }
    if (isSameDay(date, startOfDay(addDays(today(), 7)))) {
      selectedTimeOption = 'nextWeek'
    }
    if (isSameDay(date, startOfDay(addMonths(today(), 1)))) {
      selectedTimeOption = 'nextMonth'
    }
    if (isSameDay(date, startOfDay(addMonths(today(), 3)))) {
      selectedTimeOption = 'nextQuarter'
    }
    if (isSameDay(date, startOfDay(addYears(today(), 1)))) {
      selectedTimeOption = 'nextYear'
    }
  }

  return selectedTimeOption;
}